// TODO: Implement
const frankly = {
  node_modules: [
    require('react'),
    require('lodash'),
    require('react-bootstrap'),
    require('react-websocket'),
    require('classnames'),
    require('xml2js'),
    require('xml-js'),
    require('react-redux'),
    require('redux'),
    require('recharts'),
    require('rc-calendar'),
    require('axios'),
  ],
  _modules: {},
  importReactComponent(id) {
    // TODO: Implement
    return new Promise(resolve => resolve(frankly._modules[id]));
  }
};

// frankly utils and constants
frankly._modules['utils/NewsUtils'] = require('utils/NewsUtils');
frankly._modules['constants/FRNBaseStyles'] = require('constants/FRNBaseStyles');

// frankly components
frankly._modules['components/regionalization/RegionSwitcher'] = require('components/regionalization/RegionSwitcher');

frankly._modules['components/core/Header'] = require('components/core/Header');
frankly._modules['components/core/Footer'] = require('components/core/Footer');
frankly._modules['components/core/FooterNavigation'] = require('components/core/FooterNavigation');
frankly._modules['components/AdvertisementUnit'] = require('components/AdvertisementUnit');
frankly._modules['components/Image'] = require('components/Image');
frankly._modules['components/KarmaAdvertisementUnit'] = require('components/KarmaAdvertisementUnit');
frankly._modules['components/core/DummyLink'] = require('components/core/DummyLink');
frankly._modules['components/core/DummyStoryList'] = require('components/core/DummyStoryList');
frankly._modules['components/shared/IFrame'] = require('components/shared/IFrame');
frankly._modules['components/shared/Link'] = require('components/shared/Link');
frankly._modules['components/shared/CodeBlock'] = require('components/shared/CodeBlock');
frankly._modules['components/shared/ImageLink'] = require('components/shared/ImageLink');
frankly._modules['components/shared/Toolbox'] = require('components/shared/Toolbox');
frankly._modules['components/shared/PageTitle'] = require('components/shared/PageTitle');
frankly._modules['components/news/ImageSlideshow'] = require('components/news/ImageSlideshow');
frankly._modules['components/news/Slideshow'] = require('components/news/Slideshow');
frankly._modules['components/media/VideoPlayer'] = require('components/media/VideoPlayer');
frankly._modules['components/media/Video'] = require('components/media/Video');
frankly._modules['components/media/LiveStreamVideo'] = require('components/media/LiveStreamVideo');
frankly._modules['components/media/LiveStreamVideoSwitcher'] = require('components/media/LiveStreamVideoSwitcher');
frankly._modules['components/shared/PageAlertBanner'] = require('components/shared/PageAlertBanner');
frankly._modules['components/shared/ReadMoreButton'] = require('components/shared/ReadMoreButton');
frankly._modules['components/news/TabbedCategoryHeadlines'] = require('components/news/TabbedCategoryHeadlines');
frankly._modules['components/news/AssociatedContent'] = require('components/news/AssociatedContent');
frankly._modules['components/news/SliderArticleList'] = require('components/news/SliderArticleList');
frankly._modules['components/news/CategoryGrid'] = require('components/news/CategoryGrid');
frankly._modules['components/news/ArticleList'] = require('components/news/ArticleList');
frankly._modules['components/news/Article'] = require('components/news/Article');
frankly._modules['components/news/Clip'] = require('components/news/Clip');
frankly._modules['components/news/NewsBanner'] = require('components/news/NewsBanner');
frankly._modules['components/news/CardList'] = require('components/news/CardList');
frankly._modules['components/news/Card'] = require('components/news/Card');
frankly._modules['components/news/CardContainer'] = require('components/news/CardContainer');
frankly._modules['components/news/RailCardContainer'] = require('components/news/RailCardContainer');
frankly._modules['components/news/ClosingsAlert'] = require('components/news/ClosingsAlert');
frankly._modules['components/social/TwitterFeed'] = require('components/social/TwitterFeed');
frankly._modules['components/social/FacebookComments'] = require('components/social/FacebookComments');
frankly._modules['components/social/DisqusComments'] = require('components/social/DisqusComments');
frankly._modules['components/social/AddThis'] = require('components/social/AddThis');
frankly._modules['components/media/NewsyVideo'] = require('components/media/NewsyVideo');
frankly._modules['components/ads/Outbrain'] = require('components/ads/Outbrain');
frankly._modules['components/ads/SmartAppBanner'] = require('components/ads/SmartAppBanner');
frankly._modules['components/ads/Taboola'] = require('components/ads/Taboola');
frankly._modules['components/ads/Nativo'] = require('components/ads/Nativo');
frankly._modules['components/ads/EvieSays'] = require('components/ads/EvieSays');
frankly._modules['components/ads/revContent'] = require('components/ads/revContent');
frankly._modules['components/analytics/Chartbeat'] = require('components/analytics/Chartbeat');
frankly._modules['components/weather/AlertList'] = require('components/weather/AlertList');
frankly._modules['components/weather/CurrentConditionsAtAGlance'] = require('components/weather/CurrentConditionsAtAGlance');



// TODO: deprecate this
frankly._modules['components/weather/WeatherAlerts'] = require('components/weather/WeatherAlerts');
frankly._modules['components/weather/MeteorologistForecast'] = require('components/weather/MeteorologistForecast');
frankly._modules['components/weather/DailyWeatherSummary'] = require('components/weather/DailyWeatherSummary');
frankly._modules['components/weather/DetailedWeatherBreakdown'] = require('components/weather/DetailedWeatherBreakdown');
frankly._modules['components/weather/SubscribeModule'] = require('components/weather/SubscribeModule');
frankly._modules['components/weather/WeatherBlog'] = require('components/weather/WeatherBlog');
frankly._modules['components/weather/WeatherRadar'] = require('components/weather/WeatherRadar');
frankly._modules['components/weather/StationImages'] = require('components/weather/StationImages');
frankly._modules['components/weather/TeamOverview'] = require('components/weather/TeamOverview');
frankly._modules['components/weather/WeatherTeamOverview'] = require('components/weather/TeamOverview');
frankly._modules['components/weather/ViewerWeatherMedia'] = require('components/weather/ViewerWeatherMedia');

frankly._modules['components/core/TallHeader'] = require('components/core/TallHeader');
frankly._modules['components/core/CollapsibleHeader'] = require('components/core/CollapsibleHeader');
frankly._modules['components/core/SimpleNavigation'] = require('components/core/SimpleNavigation');
frankly._modules['components/search/SearchResult'] = require('components/search/SearchResult');
frankly._modules['components/weather/SimpleDailyWeatherSummary'] = require('components/weather/SimpleDailyWeatherSummary');
frankly._modules['components/weather/DailySummaryWithVideo'] = require('components/weather/DailySummaryWithVideo');
frankly._modules['components/weather/SimpleMeteorologistForecast'] = require('components/weather/SimpleMeteorologistForecast');

frankly._modules['components/ads/Zedo'] = require('components/ads/Zedo');
frankly._modules['components/ads/FlippCircular'] = require('components/ads/FlippCircular');
frankly._modules['components/thirdParty/Vuukle'] = require('components/thirdParty/Vuukle');
frankly._modules['components/thirdParty/Traqli'] = require('components/thirdParty/Traqli');

frankly._modules['components/membership/Register'] = require('components/membership/Register');
frankly._modules['components/membership/Profile'] = require('components/membership/Profile');
frankly._modules['components/membership/Login'] = require('components/membership/Login');
frankly._modules['components/membership/MemberForm'] = require('components/membership/MemberForm');
frankly._modules['components/membership/MemberWidget'] = require('components/membership/MemberWidget');
frankly._modules['components/membership/ResetPassword'] = require('components/membership/ResetPassword');
frankly._modules['components/membership/ForgetPassword'] = require('components/membership/ForgetPassword');
frankly._modules['components/membership/NewsletterSubscribe'] = require('components/membership/NewsletterSubscribe');

frankly._modules['components/GenericScriptComponent'] = require('components/GenericScriptComponent');

// Custom modules
frankly._modules['components/custom/heartland/core/Header'] = require('components/custom/heartland/core/Header');
frankly._modules['components/custom/heartland/core/SimpleNavigation'] = require('components/custom/heartland/core/SimpleNavigation');
frankly._modules['components/custom/heartland/weather/DailyWeatherSummary'] = require('components/custom/heartland/weather/DailyWeatherSummary');
frankly._modules['components/custom/heartland/weather/DailySummaryWithVideo'] = require('components/custom/heartland/weather/DailySummaryWithVideo');
frankly._modules['components/custom/heartland/weather/SimpleMeteorologistForecast'] = require('components/custom/heartland/weather/SimpleMeteorologistForecast');
frankly._modules['components/custom/heartland/thirdParty/Vuukle'] = require('components/custom/heartland/thirdParty/Vuukle');
frankly._modules['components/custom/heartland/thirdParty/FlippCircular'] = require('components/custom/heartland/thirdParty/FlippCircular');
frankly._modules['components/custom/heartland/thirdParty/Traqli'] = require('components/custom/heartland/thirdParty/Traqli');
frankly._modules['components/custom/heartland/search/SearchResult'] = require('components/custom/heartland/search/SearchResult');

frankly._modules['components/custom/griffin/SimpleArticle'] = require('components/custom/griffin/SimpleArticle');
frankly._modules['components/custom/griffin/CategoryGrid'] = require('components/custom/griffin/CategoryGrid');
frankly._modules['components/custom/griffin/SideBySideArticle'] = require('components/custom/griffin/SideBySideArticle');
frankly._modules['components/custom/griffin/SportModule'] = require('components/custom/griffin/SportModule');

try {
  frankly._modules['components/custom/ssr/Footer'] = require('components/custom/ssr/Footer');
  frankly._modules['components/custom/ssr/Header'] = require('components/custom/ssr/Header');
  frankly._modules['components/custom/ssr/HomePageTakeover'] = require('components/custom/ssr/HomePageTakeover');
  frankly._modules['components/custom/ssr/SendTo'] = require('components/custom/ssr/SendTo');
  frankly._modules['components/custom/ssr/WeatherTakeover'] = require('components/custom/ssr/WeatherTakeover');
  frankly._modules['components/custom/ssr/WarnEspRadar'] = require('components/custom/ssr/WarnEspRadar');
  frankly._modules['components/custom/ssr/WeatherBlock'] = require('components/custom/ssr/WeatherBlock');
  frankly._modules['components/custom/ssr/UControl'] = require('components/custom/ssr/UControl');
  frankly._modules['components/custom/ssr/Seismograph'] = require('components/custom/ssr/Seismograph');
  frankly._modules['components/custom/ssr/EarthquakeMap'] = require('components/custom/ssr/EarthquakeMap');
  frankly._modules['components/custom/ssr/SchoolClosings'] = require('components/custom/ssr/SchoolClosings');
  frankly._modules['components/custom/ssr/ElectionPage'] = require('components/custom/ssr/ElectionPage');
  frankly._modules['components/custom/ssr/TrafficPage'] = require('components/custom/ssr/TrafficPage');
  frankly._modules['components/custom/ssr/LayoutFullBleed'] = require('components/custom/ssr/LayoutFullBleed');
  frankly._modules['components/custom/ssr/LayoutOneByFive'] = require('components/custom/ssr/LayoutOneByFive');
  frankly._modules['components/custom/ssr/LayoutTwoByFour'] = require('components/custom/ssr/LayoutTwoByFour');
  frankly._modules['components/custom/ssr/LayoutTwoByThree'] = require('components/custom/ssr/LayoutTwoByThree');
  frankly._modules['components/custom/ssr/LayoutCarousel'] = require('components/custom/ssr/LayoutCarousel');
  frankly._modules['components/custom/ssr/LayoutOneTwoThree'] = require('components/custom/ssr/LayoutOneTwoThree');
  frankly._modules['components/custom/ssr/LayoutLandscapeList'] = require('components/custom/ssr/LayoutLandscapeList');
  frankly._modules['components/custom/ssr/LayoutOneTwoList'] = require('components/custom/ssr/LayoutOneTwoList');
  frankly._modules['components/custom/ssr/LayoutThreeByN'] = require('components/custom/ssr/LayoutThreeByN');
  frankly._modules['components/custom/ssr/LayoutOneFeature'] = require('components/custom/ssr/LayoutOneFeature');
  frankly._modules['components/custom/ssr/LayoutCarouselWithFeature'] = require('components/custom/ssr/LayoutCarouselWithFeature');
  frankly._modules['components/custom/ssr/WatchesAndWarnings'] = require('components/custom/ssr/WatchesAndWarnings');
  frankly._modules['components/custom/ssr/HelperDarkBackground'] = require('components/custom/ssr/HelperDarkBackground');
  frankly._modules['components/custom/ssr/PageTitle'] = require('components/custom/ssr/PageTitle');
  frankly._modules['components/custom/ssr/HourlyTemperatures'] = require('components/custom/ssr/HourlyTemperatures');
  frankly._modules['components/custom/ssr/Almanac'] = require('components/custom/ssr/Almanac');
  frankly._modules['components/custom/ssr/NineDayForecast'] = require('components/custom/ssr/NineDayForecast');
  frankly._modules['components/custom/ssr/PlayFirstClipFromCategory'] = require('components/custom/ssr/PlayFirstClipFromCategory');
  frankly._modules['components/custom/ssr/RadarCallToAction'] = require('components/custom/ssr/RadarCallToAction');
  frankly._modules['components/custom/ssr/SkyCam'] = require('components/custom/ssr/SkyCam');
  frankly._modules['components/custom/ssr/SkycamPage'] = require('components/custom/ssr/SkycamPage');
  frankly._modules['components/custom/ssr/WeatherAppAdvert'] = require('components/custom/ssr/WeatherAppAdvert');
  frankly._modules['components/custom/ssr/WeatherSummary'] = require('components/custom/ssr/WeatherSummary');
  frankly._modules['components/custom/ssr/WindChart'] = require('components/custom/ssr/WindChart');
  frankly._modules['components/custom/ssr/ArchiveCalendar'] = require('components/custom/ssr/ArchiveCalendar');
  frankly._modules['components/custom/ssr/Image'] = require('components/custom/ssr/Image');
  frankly._modules['components/custom/ssr/ResponsiveAdContainer'] = require('components/custom/ssr/ResponsiveAdContainer');
  frankly._modules['components/custom/ssr/WeatherAlerts'] = require('components/custom/ssr/WeatherAlerts');

  frankly._modules['components/custom/ssr/RadioBanner'] = require('components/custom/ssr/RadioBanner');
  frankly._modules['components/custom/ssr/BaronAlmanac'] = require('components/custom/ssr/BaronAlmanac');
  frankly._modules['components/custom/ssr/BaronHourlyTemperatures'] = require('components/custom/ssr/BaronHourlyTemperatures');
  frankly._modules['components/custom/ssr/BaronWindChart'] = require('components/custom/ssr/BaronWindChart');
  frankly._modules['components/custom/ssr/BaronResponsiveMap'] = require('components/custom/ssr/BaronResponsiveMap');
	frankly._modules['components/custom/ssr/BaronSevenDayForecast'] = require('components/custom/ssr/BaronSevenDayForecast');
  frankly._modules['components/custom/ssr/BaronNineDayForecast'] = require('components/custom/ssr/BaronNineDayForecast');
  frankly._modules['components/custom/ssr/BaronWeatherBlock'] = require('components/custom/ssr/BaronWeatherBlock');
  frankly._modules['components/custom/ssr/BaronWeatherSummary'] = require('components/custom/ssr/BaronWeatherSummary');
  frankly._modules['components/custom/ssr/LayoutRightRailStories'] = require('components/custom/ssr/LayoutRightRailStories');
  frankly._modules['components/custom/ssr/LayoutTwoThree'] = require('components/custom/ssr/LayoutTwoThree');
  frankly._modules['components/custom/ssr/BaronSimpleDatePicker'] = require('components/custom/ssr/BaronSimpleDatePicker');
  frankly._modules['components/custom/ssr/NwsWeatherAlerts'] = require('components/custom/ssr/NwsWeatherAlerts');


  frankly._modules['components/custom/griffin/WeatherBlock'] = require('components/custom/griffin/WeatherBlock');
  frankly._modules['components/custom/griffin/WeatherController'] = require('components/custom/griffin/WeatherController');
  frankly._modules['components/custom/griffin/Footer'] = require('components/custom/griffin/Footer');
  frankly._modules['components/custom/griffin/Header'] = require('components/custom/griffin/Header');
  frankly._modules['components/custom/griffin/BannerController'] = require('components/custom/griffin/BannerController');
  frankly._modules['components/custom/griffin/Takeover'] = require('components/custom/griffin/Takeover');
  frankly._modules['components/custom/griffin/WeatherTakeover'] = require('components/custom/griffin/WeatherTakeover');
  frankly._modules['components/custom/griffin/WarnEspRadar'] = require('components/custom/griffin/WarnEspRadar');
  frankly._modules['components/custom/griffin/Seismograph'] = require('components/custom/griffin/Seismograph');
  frankly._modules['components/shared/ComponentTitle'] = require('components/shared/ComponentTitle');
  frankly._modules['components/custom/griffin/Timestamp'] = require('components/custom/griffin/Timestamp');
  frankly._modules['components/icons/ChevronRight'] = require('components/icons/ChevronRight');
  frankly._modules['components/icons/Pagination'] = require('components/icons/Pagination');
  //frankly._modules['components/custom/meredith/SimpleArticle'] = require('components/custom/meredith/SimpleArticle');
} catch (e) {
  console.log(e);
}

if (process.env.BROWSER && window && '__cml_inject' in window){
  try {
    for (let i in window.__cml_inject) {
      if (!(i in frankly._modules) && typeof window.__cml_inject[i] === 'function') {
        frankly._modules[i] = window
          .__cml_inject[i](frankly._modules, frankly.node_modules);
      }
    }
  } catch (cml_err) {
    console.error('CML ERROR\n', cml_err);
  }
}

export default frankly;



// WEBPACK FOOTER //
// ./shared/utils/ComponentLoader.js